import Vue from "vue";
import Router from "vue-router";
import store from "@/store/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "*", redirect: "/" },
    {
      path: "/",
      name: "Landing",
      component: () => import("./views/Landing.vue")
    },
    {
      path: "/Home",
      name: "Home",
      component: () => import("./views/Home.vue"),
      props: route => ({ menu: route.query.menu }),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/Login",
      name: "Login",
      component: () => import("./views/Login.vue")
    },
    {
      path: "/HomePos1",
      name: "HomePos1",
      component: () => import("./views/HomePos1.vue")
    },
    {
      path: "/HomeAdministracion",
      name: "HomeAdministracion",
      component: () => import("./views/HomeAdministracion.vue")
    },
    {
      path: "/HomeBanco",
      name: "HomeBanco",
      component: () => import("./views/HomeBanco.vue")
    },
    {
      path: "/HomeCartera",
      name: "HomeCartera",
      component: () => import("./views/HomeCartera.vue")
    },
    {
      path: "/HomeCompra",
      name: "HomeCompra",
      component: () => import("./views/HomeCompra.vue")
    },
    {
      path: "/HomeVenta",
      name: "HomeVenta",
      component: () => import("./views/HomeVenta.vue")
    },
    {
      path: "/Venta",
      name: "Venta",
      component: () => import("./views/Venta/Venta.vue")
    },
    {
      path: "/VentaManual",
      name: "VentaManual",
      component: () => import("./views/Venta/VentaManual.vue")
    },
    {
      path: "/Cliente",
      name: "ClienteCrud",
      component: () => import("./views/Venta/ClienteCrud.vue")
    },
    {
      path: "/AnulaImpresionFiscal",
      name: "AnulaImpresionFiscal",
      component: () => import("./views/Venta/AnulaImpresionFiscal.vue")
    },
    {
      path: "/GeneraFE",
      name: "GeneraFE",
      component: () => import("./views/Venta/GeneraFE.vue")
    },
    {
      path: "/CajaCrud",
      name: "CajaCrud",
      component: () => import("./views/Caja/CajaCrud.vue")
    },
    {
      path: "/CajaCierreP",
      name: "CajaCierreP",
      component: () => import("./views/Caja/CajaCierreP.vue")
    },
    {
      path: "/CajaPosCorte",
      name: "CajaPosCorte",
      component: () => import("./views/Caja/CajaPosCorte.vue")
    },
    {
      path: "/CajaPosCierreP",
      name: "CajaPosCierreP",
      component: () => import("./views/Caja/CajaPosCierreP.vue")
    },
    {
      path: "/CajaPosCierreA",
      name: "CajaPosCierreA",
      component: () => import("./views/Caja/CajaPosCierreA.vue")
    },
    {
      path: "/Tarjeta",
      name: "TarjetaCrud",
      component: () => import("./views/Tarjeta/TarjetaCrud.vue")
    },
    {
      path: "/Cupon",
      name: "CuponCrud",
      component: () => import("./views/Tarjeta/CuponCrud.vue")
    },
    {
      path: "/Banco",
      name: "BancoCrud",
      component: () => import("./views/Banco/BancoCrud.vue")
    },
    {
      path: "/CuentaBancaria",
      name: "CuentaBancariaCrud",
      component: () => import("./views/Banco/CuentaBancariaCrud.vue")
    },
    {
      path: "/Chequera",
      name: "ChequeraCrud",
      component: () => import("./views/Banco/ChequeraCrud.vue")
    },
    {
      path: "/Cheque",
      name: "ChequeCrud",
      component: () => import("./views/Banco/ChequeCrud.vue")
    },
    {
      path: "/ChequeTercero",
      name: "ChequeTerceroCrud",
      component: () => import("./views/Cartera/ChequeTerceroCrud.vue")
    },
    {
      path: "/ProveedorCrud",
      name: "ProveedorCrud",
      component: () => import("./views/Compra/ProveedorCrud.vue")
    },
    {
      path: "/Compra",
      name: "Compra",
      component: () => import("./views/Compra/Compra.vue")
    },
    {
      path: "/Rubro",
      name: "RubroCrud",
      component: () => import("./views/Stock/RubroCrud.vue")
    },
    {
      path: "/Subrubro",
      name: "SubrubroCrud",
      component: () => import("./views/Stock/SubrubroCrud.vue")
    },
    {
      path: "/Marca",
      name: "MarcaCrud",
      component: () => import("./views/Stock/MarcaCrud.vue")
    },
    {
      path: "/Articulo",
      name: "ArticuloCrud",
      component: () => import("./views/Stock/ArticuloCrud.vue")
    },
    {
      path: "/ArticuloConsultaPrecio",
      name: "ArticuloConsultaPrecio",
      component: () => import("./views/Stock/ArticuloConsultaPrecio.vue")
    },
    {
      path: "/RubroIb",
      name: "RubroIbCrud",
      component: () => import("./views/Stock/RubroIbCrud.vue")
    },
    {
      path: "/Tecla",
      name: "TeclaCrud",
      component: () => import("./views/Stock/TeclaCrud.vue")
    },
    {
      path: "/Empleado",
      name: "EmpleadoCrud",
      component: () => import("./views/Personal/EmpleadoCrud.vue")
    },
    {
      path: "/SistemaCrud",
      name: "SistemaCrud",
      component: () => import("./views/Sistema/SistemaCrud.vue")
    },
    {
      path: "/PuntoVentaCrud",
      name: "PuntoVentaCrud",
      component: () => import("./views/Sistema/PuntoVentaCrud.vue")
    },
    {
      path: "/TalonarioCrud",
      name: "TalonarioCrud",
      component: () => import("./views/Sistema/TalonarioCrud.vue")
    },
    {
      path: "/TipoComprobante_TalonarioCrud",
      name: "TipoComprobante_TalonarioCrud",
      component: () =>
        import("./views/Sistema/TipoComprobante_TalonarioCrud.vue")
    },
    {
      path: "/UsuarioCrud",
      name: "UsuarioCrud",
      component: () => import("./views/Sistema/UsuarioCrud.vue")
    },
    {
      path: "/VentaListarLibroIva",
      name: "VentaListarLibroIva",
      component: () => import("./views/Venta/Reports/VentaListarLibroIva.vue")
    },
    {
      path: "/VentaListarLibroPercepcionIb",
      name: "VentaListarLibroPercepcionIb",
      component: () =>
        import("./views/Venta/Reports/VentaListarLibroPercepcionIb.vue")
    },
    {
      path: "/VentaListarPorCliente",
      name: "VentaListarPorCliente",
      component: () => import("./views/Venta/Reports/VentaListarPorCliente.vue")
    },
    {
      path: "/VentaListarSaldos",
      name: "VentaListarSaldos",
      component: () => import("./views/Venta/Reports/VentaListarSaldos.vue")
    },
    {
      path: "/CajaListarSaldos",
      name: "CajaListarSaldos",
      component: () => import("./views/Caja/Reports/CajaListarSaldos.vue")
    },
    {
      path: "/ChequeListarPorChequera",
      name: "ChequeListarPorChequera",
      component: () =>
        import("./views/Banco/Reports/ChequeListarPorChequera.vue")
    },
    {
      path: "/ChequeListarPorFechaPago",
      name: "ChequeListarPorFechaPago",
      component: () =>
        import("./views/Banco/Reports/ChequeListarPorFechaPago.vue")
    },
    {
      path: "/ChequeTerceroListarPorEstado",
      name: "ChequeTerceroListarPorEstado",
      component: () =>
        import("./views/Cartera/Reports/ChequeTerceroListarPorEstado.vue")
    },
    {
      path: "/CompraListarLibroIva",
      name: "CompraListarLibroIva",
      component: () => import("./views/Compra/Reports/CompraListarLibroIva.vue")
    },
    {
      path: "/CompraListarPorProveedor",
      name: "CompraListarPorProveedor",
      component: () =>
        import("./views/Compra/Reports/CompraListarPorProveedor.vue")
    },
    {
      path: "/CompraListarSaldos",
      name: "CompraListarSaldos",
      component: () => import("./views/Compra/Reports/CompraListarSaldos.vue")
    },
    {
      path: "/StockListarPrecios",
      name: "StockListarPrecios",
      component: () => import("./views/Stock/Reports/StockListarPrecios.vue")
    },
    {
      path: "/StockListarSaldos",
      name: "StockListarSaldos",
      component: () => import("./views/Stock/Reports/StockListarSaldos.vue")
    },
    {
      path: "/StockListarFicha",
      name: "StockListarFicha",
      component: () => import("./views/Stock/Reports/StockListarFicha.vue")
    },
    {
      path: "/ComprobanteListarPorTipoComprobante",
      name: "ComprobanteListarPorTipoComprobante",
      component: () =>
        import("./views/Sistema/Reports/ComprobanteListarPorTipoComprobante.vue")
    },
    {
      path: "/ComprobanteAnularPorTipoComprobante",
      name: "ComprobanteAnularPorTipoComprobante",
      component: () =>
        import("./views/Sistema/ComprobanteAnularPorTipoComprobante.vue")
    },
    {
      path: "/ComprobanteControlarNumeracionPorTipoComprobante",
      name: "ComprobanteControlarNumeracionPorTipoComprobante",
      component: () =>
        import("./views/Sistema/ComprobanteControlarNumeracionPorTipoComprobante.vue")
    },
    {
      path: "/CreaBackup",
      name: "CreaBackup",
      component: () => import("./views/Sistema/CreaBackup.vue")
    }
  ]
});

//mGuy: active authentication option.
router.beforeEach((to, from, next) => {
  if (to.path == "/" || to.path == "/Login") {
    next();
  } else {
    if (store.getters.isAuthenticated && store.state.nombreRol != "") next();
    else next("/Login");
  }
});

export default router;
